// Uma requisição por vez. Uma invalidação durante a busca descarta a resposta
// ultrapassada e agrupa as invalidações em uma única busca seguinte.
export function createRefreshQueue(load, apply) {
  let revision = 0
  let running = null

  return () => {
    revision += 1
    if (running) return running

    running = (async () => {
      while (true) {
        const requested = revision
        let data
        try {
          data = await load()
        } catch (error) {
          if (requested !== revision) continue
          throw error
        }
        if (requested !== revision) continue
        apply(data)
        return
      }
    })().finally(() => { running = null })
    return running
  }
}
